export default {
  loaded: false,
  characterSelection: false,
  introDone: false,
  isGameLoading: false,
  isGamePlaying: false,
  isGameOver: false,
  showPause: true,

  characterId: 'florence',
  tutorial: -1,
  score: 0,
  life: 3,
  mt: 0,
  level: 1,
  powerUpPercentage: 0,

  userData: null,
};
